/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Article {
  active?: boolean;
  articleAuthor?: string;
  articleBody?: string;
  articleDescription?: string;
  articleId?: number;
  articleImage?: string;
  articleKeywords?: string;
  articleSummary?: string;
  articleTags?: string;
  articleTitle?: string;
  articleType?: number;
  articleTypeName?: string;
  dateCreated?: Date;
  dateUpdated?: Date;
  minutesTotal?: number;
  publishDate?: Date;
  unpublishDate?: Date;
  videoURL?: string;
  websiteId?: number;
}
